import DefaultNavbar from "examples/Navbars/DefaultNavbar";

import routes from "routes";
import MKBox from "components/MKBox";
import DefaultFooter from "examples/Footers/DefaultFooter";
import footerRoutes from "footer.routes";
import { useState } from "react";
import {
  Box,
  Container,
  Typography,
  Grid,
  TextField,
  MenuItem,
  Paper,
  Button,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import { uploadToCloudinary } from "../../services/cloudinaryUpload";
import { sendEmail } from "../../services/emailjs";
import { Helmet } from "react-helmet-async";

const MAX_FILE_SIZE = 2 * 1024 * 1024; // 2MB

export default function AfiliatePage() {
  const [accepted, setAccepted] = useState(false);
  const FORM_TYPE = "Solicitud de Afiliación";
  const [formData, setFormData] = useState({
    cuil: "",
    nombres: "",
    apellido: "",
    dni: "",
    email: "",
    telefono: "",
    nacionalidad: "",
    sexo: "",
    estado_civil: "",
    fecha_nacimiento: "",
    calle: "",
    numero: "",
    piso: "",
    depto: "",
    codigo_postal: "",
    localidad: "",
    categoria: "",
    fecha_ingreso: "",
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const [files, setFiles] = useState({
    dni_frente: null,
    dni_dorso: null,
    recibo: null,
  });
  const [fileErrors, setFileErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleFileChange = (e, key) => {
    const file = e.target.files[0];
    if (!file) return;

    if (file.size > MAX_FILE_SIZE) {
      setFileErrors((prev) => ({
        ...prev,
        [key]: "El archivo supera los 2 MB",
      }));
      return;
    }

    setFileErrors((prev) => ({ ...prev, [key]: null }));
    setFiles((prev) => ({ ...prev, [key]: file }));
  };

  const handleSubmit = async () => {
    setLoading(true);

    try {
      const uploadedUrls = {};

      for (const key in files) {
        if (files[key]) {
          const uploaded = await uploadToCloudinary(files[key]);
          uploadedUrls[key] = uploaded.secure_url;
        }
      }

      await sendEmail({
        tipo_solicitud: FORM_TYPE,
        ...formData,

        dni_frente: uploadedUrls.dni_frente || "No adjunto",
        dni_dorso: uploadedUrls.dni_dorso || "No adjunto",
        recibo: uploadedUrls.recibo || "No adjunto",
      });

      alert("Solicitud enviada correctamente");
    } catch (error) {
      console.error(error);
      alert("Error al enviar la solicitud");
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <Helmet>
        <title>Afiliación de Trabajadores | Sindicato Panaderos San Juan</title>

        <meta
          name="description"
          content="Formulario de afiliación online para trabajadores panaderos de San Juan. Completá tus datos, adjuntá tu documentación y unite al sindicato de forma digital."
        />

        <meta
          name="keywords"
          content="afiliarse sindicato panaderos, sindicato panaderos san juan, beneficios afiliados panaderos, formulario afiliación panadería, gremio panaderos san juan"
        />

        {/* Open Graph para que al enviar el link por WhatsApp se vea profesional */}
        <meta
          property="og:title"
          content="Afiliación Online - Sindicato de Panaderos de San Juan"
        />
        <meta
          property="og:description"
          content="Unite al sindicato. Completá el formulario de afiliación y accedé a todos los beneficios para el trabajador panadero."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="http://sindicatopanaderossanjuan.com.ar/afiliate" />

        {/* Evita que Google indexe versiones con parámetros extraños */}
        <link rel="canonical" href="http://sindicatopanaderossanjuan.com.ar/afiliate" />
      </Helmet>
      <DefaultNavbar routes={routes} />

      <Container maxWidth="lg" sx={{ py: 6, paddingTop: "6rem" }}>
        {/* TÍTULO */}
        <Typography variant="h4" fontWeight="bold" mb={1}>
          AFILIACION
        </Typography>

        <Box
          sx={{
            width: "100%",
            height: "3px",
            backgroundColor: "#2196f3",
            mb: 4,
          }}
        />

        <Paper sx={{ p: 4, borderRadius: 3 }}>
          {/* SUBTÍTULO */}
          <Typography variant="h5" fontWeight="bold" gutterBottom>
            Solicitud de Afiliación
          </Typography>

          {/* DATOS PERSONALES */}
          <Typography variant="h6" sx={{ mt: 3, mb: 2 }}>
            Datos Personales
          </Typography>

          <Grid container spacing={2}>
            <Grid item xs={12} sm={4}>
              <TextField
                label="CUIL"
                name="cuil"
                value={formData.cuil}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                label="Nombres"
                name="nombres"
                value={formData.nombres}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                label="Apellido"
                name="apellido"
                value={formData.apellido}
                onChange={handleChange}
                fullWidth
              />
            </Grid>

            <Grid item xs={12} sm={4}>
              <TextField
                label="Nacionalidad"
                name="nacionalidad"
                value={formData.nacionalidad}
                onChange={handleChange}
                fullWidth
              />
            </Grid>

            <Grid item xs={12} sm={4}>
              <TextField
                label="Sexo"
                name="sexo"
                select
                value={formData.sexo}
                onChange={handleChange}
                fullWidth
              >
                <MenuItem value="M">Masculino</MenuItem>
                <MenuItem value="F">Femenino</MenuItem>
                <MenuItem value="O">Otro</MenuItem>
              </TextField>
            </Grid>

            <Grid item xs={12} sm={4}>
              <TextField
                label="Email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                fullWidth
              />
            </Grid>

            <Grid item xs={12} sm={4}>
              <TextField
                label="Telefono"
                name="telefono"
                value={formData.telefono}
                onChange={handleChange}
                fullWidth
              />
            </Grid>

            <Grid item xs={12} sm={4}>
              <TextField
                label="Categoria laboral"
                name="categoria"
                value={formData.categoria}
                onChange={handleChange}
                fullWidth
              />
            </Grid>

            <Grid item xs={12} sm={4}>
              <TextField
                label="Fecha de ingreso"
                type="date"
                name="fecha_ingreso"
                value={formData.fecha_ingreso}
                onChange={handleChange}
                fullWidth
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            <Grid item xs={12} sm={4}>
              <TextField
                label="Calle"
                name="calle"
                value={formData.calle}
                onChange={handleChange}
                fullWidth
              />
            </Grid>

            <Grid item xs={12} sm={2}>
              <TextField
                label="Número"
                name="numero"
                value={formData.numero}
                onChange={handleChange}
                fullWidth
              />
            </Grid>

            <Grid item xs={12} sm={2}>
              <TextField
                label="Piso"
                name="piso"
                value={formData.piso}
                onChange={handleChange}
                fullWidth
              />
            </Grid>

            <Grid item xs={12} sm={2}>
              <TextField
                label="departamento"
                name="depto"
                value={formData.depto}
                onChange={handleChange}
                fullWidth
              />
            </Grid>

            <Grid item xs={12} sm={2}>
              <TextField
                label="Código postal"
                name="codigo_postal"
                value={formData.codigo_postal}
                onChange={handleChange}
                fullWidth
              />
            </Grid>

            <Grid item xs={12} sm={4}>
              <TextField
                label="Localidad"
                name="localidad"
                value={formData.localidad}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
          </Grid>

          {/* DATOS ADICIONALES */}
          <Typography variant="h6" sx={{ mt: 4, mb: 2 }}>
            Datos Adicionales
          </Typography>

          <Grid container spacing={2}>
            <Grid item xs={12} sm={4}>
              <TextField
                label="DNI"
                name="dni"
                value={formData.dni}
                onChange={handleChange}
                fullWidth
              />
            </Grid>

            <Grid item xs={12} sm={4}>
              <TextField
                label="Estado Civil"
                name="estado_civil"
                select
                value={formData.estado_civil}
                onChange={handleChange}
                fullWidth
              >
                <MenuItem value="" disabled>
                  Seleccione una opción
                </MenuItem>
                <MenuItem value="soltero">Soltero/a</MenuItem>
                <MenuItem value="casado">Casado/a</MenuItem>
                <MenuItem value="conviviente">Conviviente</MenuItem>
                <MenuItem value="divorciado">Divorciado/a</MenuItem>
              </TextField>
            </Grid>

            <Grid item xs={12} sm={4}>
              <TextField
                label="Fecha de nacimiento"
                type="date"
                name="fecha_nacimiento"
                value={formData.fecha_nacimiento}
                onChange={handleChange}
                fullWidth
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
          </Grid>

          {/* DOCUMENTACIÓN */}
          <Typography variant="h6" sx={{ mt: 4, mb: 1 }}>
            Documentación requerida
          </Typography>

          <Typography variant="body2" mb={2}>
            Adjunte la siguiente documentación en formato digital:
          </Typography>

          <Grid container spacing={2}>
            <Grid item xs={12} sm={4}>
              <Button
                variant="outlined"
                component="label"
                fullWidth
                sx={{
                  color: files.dni_frente ? "success.main" : "primary.main",
                  borderColor: files.dni_frente ? "success.main" : "primary.main",
                }}
              >
                DNI Frente
                <input
                  type="file"
                  hidden
                  accept="image/*,.pdf"
                  onChange={(e) => handleFileChange(e, "dni_frente")}
                />
              </Button>

              {fileErrors.dni_frente && (
                <Typography color="error" variant="caption">
                  {fileErrors.dni_frente}
                </Typography>
              )}
            </Grid>

            <Grid item xs={12} sm={4}>
              <Button
                variant="outlined"
                component="label"
                fullWidth
                sx={{
                  color: files.dni_dorso ? "success.main" : "primary.main",
                  borderColor: files.dni_dorso ? "success.main" : "primary.main",
                }}
              >
                DNI Dorso
                <input
                  type="file"
                  hidden
                  accept="image/*,.pdf"
                  onChange={(e) => handleFileChange(e, "dni_dorso")}
                />
              </Button>

              {fileErrors.dni_dorso && (
                <Typography color="error" variant="caption">
                  {fileErrors.dni_dorso}
                </Typography>
              )}
            </Grid>

            <Grid item xs={12} sm={4}>
              <Button
                variant="outlined"
                component="label"
                fullWidth
                color={files.recibo ? "success" : "primary"}
                sx={{
                  color: files.recibo ? "success.main" : "primary.main",
                  borderColor: files.recibo ? "success.main" : "primary.main",
                }}
              >
                {files.recibo ? "Recibo cargado" : "Recibo"}

                <input
                  type="file"
                  hidden
                  accept="image/*,.pdf"
                  onChange={(e) => handleFileChange(e, "recibo")}
                />
              </Button>
              {fileErrors.recibo && (
                <Typography color="error" variant="caption">
                  {fileErrors.recibo}
                </Typography>
              )}
            </Grid>
          </Grid>

          {/* TERMINOS */}
          <Box mt={4}>
            <FormControlLabel
              control={
                <Checkbox checked={accepted} onChange={(e) => setAccepted(e.target.checked)} />
              }
              label="Declaro haber leído y aceptar los requisitos para ser afiliado. Este formulario tiene carácter de declaración jurada."
            />
          </Box>

          <Button
            variant="contained"
            size="large"
            disabled={!accepted || loading}
            sx={{ mt: 3 }}
            onClick={handleSubmit}
          >
            {loading ? "Enviando..." : "ENVIAR SOLICITUD"}
          </Button>
        </Paper>
      </Container>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}
